// Library methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import SelectDropdown from "src/components/shared/inputs/SelectDropdown/SelectDropdown";

// Utils
import { pollIntervalOptions } from "src/utils/emr/worklistTimingHelper";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type PollIntervalType = {
  idPrefix: string;
  minutes: number;
  onChange: (minutes: number) => void;
};

const PollInterval = ({ idPrefix, minutes, onChange }: PollIntervalType) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  return (
    <Box display="flex" alignItems="center" gap="8px" flexWrap="wrap">
      <Typography
        id={`${idPrefix}-poll-interval-label`}
        fontSize="13px"
        color={onSurface}
      >
        {t("Check for new exams every")}
      </Typography>
      <Box width="88px">
        <SelectDropdown
          id={`${idPrefix}-poll-interval-dropdown`}
          labelId={`${idPrefix}-poll-interval-label`}
          dropdownOptions={pollIntervalOptions(minutes)}
          value={String(minutes)}
          handleChange={(event) => onChange(Number(event.target.value))}
        />
      </Box>
      <Typography fontSize="13px" color={onSurface}>
        {t("min")}
      </Typography>
    </Box>
  );
};

export default PollInterval;
